import { createApp } from 'vue'

createApp(App).mount('#app')

import Vue from "vue";
import App from "./App.vue";

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAGrIer4m94nApgPoo7g2LNSpdSZW9v8KM",
  authDomain: "platypuscoin.firebaseapp.com",
  projectId: "platypuscoin",
  storageBucket: "platypuscoin.appspot.com",
  messagingSenderId: "220632927722",
  appId: "1:220632927722:web:d2d16054916fb0453c3693",
  measurementId: "G-CMWQTMKB4X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

logEvent(analytics, 'notification_received');

new Vue({
  render: h => h(App)
}).$mount("#app");